/**
 * Skynet · sk-rating (módulo 8)
 * - Enlaza las estrellas con el muro de reseñas de la página (si no hay muro, no es un enlace).
 * - Sin reseñas reales en el producto: copia nota y número del bloque «SK · Reseñas» de la página.
 *   Si no hay ninguno con reseñas, el bloque no se muestra. Nunca inventa una cifra.
 */
class SkRating extends HTMLElement {
  connectedCallback() {
    const all = [...document.querySelectorAll('sk-reviews[data-count]')].filter((r) => Number(r.dataset.count) > 0);
    const wall = all.find((r) => r.classList.contains('sk-reviews--wall')) || all[0] || null;
    const link = this.querySelector('[data-sk-rating-link]');
    if (link) {
      if (wall?.id) link.setAttribute('href', `#${wall.id}`);
      else link.removeAttribute('href');
    }
    if (!this.hasAttribute('data-from-page')) return;
    const source = wall;
    this.removeAttribute('data-pending');
    if (!source) {
      // Sin reseñas en la página: queda invisible pero con su hueco (nada se mueve en la primera pantalla).
      this.setAttribute('data-pending', '');
      this.setAttribute('aria-hidden', 'true');
      return;
    }
    const value = Number(source.dataset.avg) || 0;
    const text = (this.dataset.template || '[rating] · [count]')
      .replace('[rating]', source.dataset.avgText || String(value))
      .replace('[count]', source.dataset.countText || source.dataset.count);
    const textEl = this.querySelector('[data-sk-rating-text]');
    if (textEl) textEl.textContent = text;
    const stars = this.querySelector('.sk-stars');
    if (stars) {
      stars.setAttribute('aria-label', (this.dataset.starsTemplate || '__V__').replace('__V__', source.dataset.avgText || String(value)));
      [...stars.querySelectorAll('.sk-stars__star')].forEach((star, i) => {
        const n = i + 1;
        const kind = value >= n ? 'full' : value >= n - 0.5 ? 'half' : 'empty';
        star.classList.remove('sk-stars__star--full', 'sk-stars__star--half', 'sk-stars__star--empty');
        star.classList.add(`sk-stars__star--${kind}`);
      });
    }
  }
}

if (!customElements.get('sk-rating')) customElements.define('sk-rating', SkRating);
